module.exports = __webpack_public_path__ + "img/20190620162441159.12c16b62.png";